<template>
    <customModal :containermd="true" @closeModal="closeModal">
        <template #title>
        <span>Manage Visit</span>
        </template>

        <template #body>
            <div class="modal-scroll-body">
                <div class="row ml-1">
                       <div class="col-md-6 mb-3">
                        <label class="form-label mb-0">Visit No.</label>
                        <input class="form-control" type="text" disabled v-model="visitNo" >                          
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label mb-0">Visit Name</label>
                        <input class="form-control" type="text" disabled v-model="visitName" >                          
                    </div>

                    <!-- Visit Status -->
                   <div class="col-md-6 mb-3">
                        <label class="form-label mb-0">Visit Status</label>

                        <select class="form-control" v-model="form.visitStatus" @change="errors.visitStatus = ''">

                            <option value="">Select</option>

                            <option v-for="status in Status" :key="status.status" :value="status.status">

                                {{ status.status }}

                            </option>

                        </select>
                    </div>

                    <!-- Planned Visit Date -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label mb-0">Planned Visit Date</label>
                        <flat-pickr v-model="form.plannedVisitDate" :config="dateTimePickerConfig" 
                        class="fp-datetime-input w-100 visit-datetime-input" />

                    </div>

                    <!-- Actual Start -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label mb-0">Visit Start Date</label>
                         <flat-pickr v-model="form.actualStartDate" :config="dateTimePickerConfig" 
                        class="fp-datetime-input w-100 visit-datetime-input" />
                    </div>

                    <!-- Actual End -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label mb-0">Visit End Date</label>
                        <flat-pickr v-model="form.actualEndDate" :config="dateTimePickerConfig" 
                        class="fp-datetime-input w-100 visit-datetime-input" />
                    </div>

                    <div class="col-md-6 mb-3">
                        <label class="form-label mb-0">Cycle Name</label>
                        <select class="form-control" v-model="selectedCycleId" @change="onCycleChange">
                            <option value="">Select</option>
                            <option v-for="cycle in sortedCycleList" :key="cycle.cycleId" :value="cycle.cycleId">
                                {{ cycle.cycleName }}
                            </option>
                        </select>
                    </div>


                    <!-- Occurrence -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label mb-0">Occurrence</label>
                        <input type="number" class="form-control" v-model.number="form.occurrence" />
                    </div>


                    <div class="col-12 text-end mt-3">
                        <button class="save_btn px-4 py-1" @click="save">
                        <span v-if="showCreateLoader == false">Save</span>
                        <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                        </button>
                    </div>

                </div>
            </div>
        </template>
    </customModal>
</template>
<script src="./MangeVisit.js"></script>
<style scoped>
:deep(.fp-datetime-input.flatpickr-input),
:deep(.fp-datetime-input.flatpickr-input:focus),
:deep(.fp-datetime-input.flatpickr-input.active) {
  background-color: #ffffff;
  background-image: none;
  border: 1px solid #e5e6e7;
  border-radius: 1px;
  color: inherit;
  display: block;
  width: 100%;
  min-height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  box-sizing: border-box;
  box-shadow: none;
  outline: none;
  transition: none;
}

:deep(.fp-datetime-input.flatpickr-input:focus),
:deep(.fp-datetime-input.flatpickr-input.active) {
  border-color: #145faf;
}

:deep(input.fp-datetime-input.flatpickr-input.active) {
  position: static !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  display: block !important;
}

:deep(.fp-datetime-input.flatpickr-input:disabled) {
  background-color: #e9ecef;
  cursor: not-allowed;
}
</style>